<template>
    <Breadcrumbs main="Widgets" title="Join Us" />
    <div class="container-fluid">

        <orderChart />

    </div>
</template>
<script lang="ts" setup>
import { defineAsyncComponent } from 'vue';

const orderChart = defineAsyncComponent(() => import("@/components/pages/joinUs/index.vue"))
</script>